/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Typography, Button, Space, Row, Col } from 'antd';
import { ArrowLeftOutlined, EditOutlined, StopOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import EndTripModal from '../EndTripModal';
import EndTripModalV2 from '../EndTripModalV2';
import InvalidTripModal from './InvalidTripModal';
import { ACL } from 'components/common';
import { TRIP_STATUS_ID } from 'utils/tripStatus';

const { Title, Text } = Typography;

function TripHeader({ tripData, isEnded, isValid, isVendorBilled }) {
	const navigate = useNavigate();
	const { tripId: urlTripId } = useParams();
	const [isEndTripModalVisible, setIsEndTripModalVisible] = useState(false);
	const [isInvalidTripModalOpen, setIsInvalidTripModalOpen] = useState(false);
	const [isTripValid, setIsTripValid] = useState(isValid);

	useEffect(() => {
		setIsTripValid(isValid);
	}, [isValid]);

	const clientName = tripData?.client_name || '';
	const projectName = tripData?.project_name || '';
	const isInterCityTrip = tripData?.info?.is_inter_city === true;
	const tripStatusId = Number(tripData?.trip_status_id ?? tripData?.info?.trip_status_id);
	const canMarkInvalid = [TRIP_STATUS_ID.REPORTED, TRIP_STATUS_ID.CREATED].includes(tripStatusId);
	const isPerOrderTrip =
		tripData?.billing_subtype === 'Per Order' ||
		tripData?.info?.billing_subtype === 'Per Order';

	const handleEndTripClick = () => {
		setIsEndTripModalVisible(true);
	};

	const handleCloseModal = () => {
		setIsEndTripModalVisible(false);
	};

	const handleInvalidModalClose = () => {
		setIsInvalidTripModalOpen(false);
	};
	const displayTripId = tripData?.trip_id || tripData?.id || '-';
	return (
		<>
			{/* eslint-disable-next-line no-nested-ternary */}
			<Row
				justify="space-between"
				align="middle"
				style={{
					backgroundColor: '#fff',
					padding: '16px 24px',
					margin: '-24px -24px 24px -24px',
					borderBottom: '1px solid #f0f0f0',
				}}
			>
				<Col>
					<Space align="start" size="middle">
						<Button
							type="text"
							icon={<ArrowLeftOutlined />}
							onClick={() => navigate(-1)}
							style={{
								marginTop: '4px',
								backgroundColor: '#fff',
								border: '1px solid #d9d9d9',
								borderRadius: '50%',
							}}
						/>
						<div>
							<Title level={4} style={{ margin: 0, fontWeight: 600 }}>
								Trip Tracking: {displayTripId}
							</Title>
							<Text type="secondary" style={{ fontSize: '13px' }}>
								{clientName} • Project {projectName}
							</Text>
						</div>
					</Space>
				</Col>

				<Col>
					<Space>
						{!isEnded ? (
							<>
								<ACL action="update" module="trip">
									{tripData && (
										<Button
											icon={<EditOutlined />}
											disabled={!isTripValid}
											style={{ borderRadius: '6px' }}
											onClick={() => {
												const currentTripId = displayTripId;
												if (isInterCityTrip) {
													navigate(
														`/trips/${currentTripId}/add-intercity`
													);
												} else {
													navigate(
														`/trips/${currentTripId}/add-intracity`
													);
												}
											}}
										>
											Edit Trip
										</Button>
									)}
								</ACL>
								<Button
									type="primary"
									danger
									disabled={!isTripValid}
									style={{ borderRadius: '6px' }}
									onClick={handleEndTripClick}
								>
									Close Trip
								</Button>
								{canMarkInvalid && (
									<ACL action="search" module="invalidate_trip">
										<Button
											type="primary"
											disabled={isVendorBilled || !isTripValid}
											style={{
												backgroundColor: '#FF3B30',
												borderColor: '#FF3B30',
												borderRadius: '6px',
											}}
											onClick={() => setIsInvalidTripModalOpen(true)}
										>
											<span
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 6,
												}}
											>
												<StopOutlined
													style={{ fontSize: 16, marginRight: 4 }}
												/>
												Mark Invalid
											</span>
										</Button>
									</ACL>
								)}
							</>
						) : (
							canMarkInvalid && (
								<ACL action="search" module="invalidate_trip">
									<Button
										type="primary"
										disabled={isVendorBilled || !isTripValid}
										style={{
											backgroundColor: '#FF3B30',
											borderColor: '#FF3B30',
											borderRadius: '6px',
										}}
										onClick={() => setIsInvalidTripModalOpen(true)}
									>
										<span
											style={{
												display: 'flex',
												alignItems: 'center',
												gap: 6,
											}}
										>
											<StopOutlined
												style={{ fontSize: 16, marginRight: 4 }}
											/>
											Mark Invalid
										</span>
									</Button>
								</ACL>
							)
						)}
					</Space>
				</Col>
			</Row>

			{isPerOrderTrip ? (
				<EndTripModalV2
					visible={isEndTripModalVisible}
					onClose={handleCloseModal}
					trip={{ ...tripData, id: tripData?.id || urlTripId }}
					perOrderRates={tripData?.order_rates}
				/>
			) : (
				<EndTripModal
					visible={isEndTripModalVisible}
					onClose={handleCloseModal}
					trip={{ ...tripData, id: tripData?.id || urlTripId }}
				/>
			)}
			<InvalidTripModal
				open={isInvalidTripModalOpen}
				onClose={handleInvalidModalClose}
				tripId={displayTripId}
				onSuccess={() => setIsTripValid(false)}
			/>
		</>
	);
}

TripHeader.propTypes = {
	tripData: PropTypes.object,
	isEnded: PropTypes.bool,
	isValid: PropTypes.bool,
	isVendorBilled: PropTypes.bool,
};

export default TripHeader;
